document.addEventListener("DOMContentLoaded", function () {
    const miniCart = document.querySelector("#mini-cart");
    const cartIcon = document.querySelector(".icon-cart_header");

    if (miniCart && cartIcon) {
        let userClickedCart = false;

        // MutationObserver to detect when "open" is added
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === "open" && !userClickedCart) {
                    requestAnimationFrame(() => {
                        miniCart.removeAttribute("open");
                    });
                }
            });
        });

        observer.observe(miniCart, { attributes: true });

        // When user clicks cart icon, allow "open" to stay
        cartIcon.addEventListener("click", function (event) {
            userClickedCart = true;

            // Use a slight delay to ensure Shopify's script runs first
            setTimeout(() => {
                miniCart.setAttribute("open", ""); // Make sure "open" is added
            }, 10);

            // Reset userClickedCart after a short delay
            setTimeout(() => {
                userClickedCart = false;
            }, 1000);
        });
    }
});
